import React, { useState } from "react";
import { Twitter, Facebook, Link2, Mail } from "lucide-react";
import ShareButton from "./components/share/ShareButton";
import { copyToClipboard } from "./lib/clipboard";

function buildShareItems(title, text, url) {
  return [
    {
      key: "twitter",
      label: "X / Twitter",
      icon: Twitter,
      href: `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`,
    },
    {
      key: "facebook",
      label: "Facebook",
      icon: Facebook,
      href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
    },
    {
      key: "email",
      label: "Email",
      icon: Mail,
      href: `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(text + "\n\n" + url)}`,
    },
  ];
}

export default function ShareBar({ title = "The Hundredth Monkey", variant = "inline" }) {
  const [copied, setCopied] = useState(false);
  const url = typeof window !== "undefined" ? window.location.origin : "";
  const text = `${title} — read it, share it, be the hundredth monkey.`;
  const items = buildShareItems(title, text, url);

  const handleCopy = async () => {
    const ok = await copyToClipboard(url);
    if (ok) {
      setCopied(true);
      setTimeout(() => setCopied(false), 1600);
    }
  };

  return (
    <div
      className={
        "flex flex-wrap items-center gap-3 " +
        (variant === "stacked" ? "flex-col items-stretch" : "")
      }
      data-testid="share-bar"
    >
      <span className="eyebrow mr-2">Pass it on</span>
      {items.map(({ key, ...rest }) => (
        <ShareButton key={key} shareKey={key} {...rest} />
      ))}
      <button
        type="button"
        className="btn-ghost"
        onClick={handleCopy}
        data-testid="share-copy-link"
      >
        <Link2 size={14} />
        <span>{copied ? "Copied!" : "Copy Link"}</span>
      </button>
    </div>
  );
}
